__turbopack_context__.v({
  "absolute": "pv_wuq_absolute",
  "fixed": "pv_wuq_fixed",
  "root": "pv_wuq_root",
});
